import '../style.scss';
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import 'react-phone-input-2/lib/style.css';
import { IEditReportState } from '../models/IEditReportState';
import Popover from 'react-bootstrap/Popover';
import 'bootstrap/dist/css/bootstrap.min.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import 'react-datepicker/dist/react-datepicker.css';
import Select, { MultiValue } from 'react-select';
import { IRestorationPledgeTrackingTab, IResultsAndBenefitsItem } from '../models/IEditReportState';
import QueryService from '../../../../shared/queryService';
import ConfigService from '../../../../shared/configService';
import { IRefPledgeEcosystemTypeFeature, IRefPledgeInitiativeFeature, IRefPreviouslyReportedFeature, IRefCurrentPledgeFeature, IRefPledgeFulfilFeature, IRefPledgeImplementFeature } from '../models/IRefFeature';
import { IFeature } from '@esri/arcgis-rest-types';
import { ToastContainer, toast } from 'react-toastify';
import Utils from '../../../../shared/utils';
import IReportMainFeature from '../models/IReportMainFeature';
import ReactDatePicker from 'react-datepicker';
import 'react-dropdown-tree-select/dist/styles.css';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
const SectorRestorationPledge = (props: { state: IEditReportState, setState: Function, validateData: Function }) => {
  const { t } = useTranslation('sectorreports');
  const MAX_LENGTH = ConfigService.getConfig().textEditorCharLength;

  //Popup buttons
  let baselineYearPopoverBtn: HTMLButtonElement;
  let pledgeEndDatePopoverBtn: HTMLButtonElement;

  const baselineYearPopover = (
    <Popover id="baselinePopover">
      <div dangerouslySetInnerHTML={{ __html: t('newReport.restorationPledge.baselineYearExplanation') }}></div>
      <div className="popoverActionsDiv">
        <button onClick={() => togglePopup1()}>{t('newReport.restorationPledge.gotIt')}</button>
      </div>
    </Popover>
  );

  const pledgeEndDatePopover = (
    <Popover id="pledgeEndDatePopover">
      <div dangerouslySetInnerHTML={{ __html: t('newReport.restorationPledge.pledgeEndDateExplanation') }}></div>
      <div className="popoverActionsDiv">
        <button onClick={() => togglePopup2()}>{t('newReport.restorationPledge.gotIt')}</button>
      </div>
    </Popover>
  );

  //Popups toggle
  const togglePopup1 = () => {
    if (baselineYearPopoverBtn) {
      baselineYearPopoverBtn.click();
    }
  }

  const togglePopup2 = () => {
    if (pledgeEndDatePopoverBtn) {
      pledgeEndDatePopoverBtn.click();
    }
  }

  /**
   * Get otherInitiativeInputEnabled 
   * @param val
   */
  const getOtherInitiativeInputEnabled = (val: string): boolean => {
    return val.split(',').some((i: string) => i === ConfigService.getConfig().agol.referenceTables.otherKeyValue);
  }

  /**
   * Get otherEcosystemInputEnabled 
   * @param val
   */
  const getOtherEcosystemInputEnabled = (val: string): boolean => {
    return val.split(',').some((i: string) => i === ConfigService.getConfig().agol.referenceTables.otherKeyValue);
  }

  /**
   * Get otherPledgeImpementInputEnabled 
   * @param val
   */
  const getOtherPledgeImpementInputEnabled = (val: string): boolean => {
    return val.split(',').some((i: string) => i === ConfigService.getConfig().agol.referenceTables.otherKeyValue);
  }

  const getOtherPledgeImpementFinancialInputEnabled = (val: string): boolean => {
    return val.split(',').some((i: string) => i === ConfigService.getConfig().agol.referenceTables.financialSupportKeyValue);
  }

  /**
   * Local state
   */
  interface ILocalState {
    reportLayerIndex: number;
    importReportDisabled: boolean;
    refPledgeInitiativeFeature: IRefPledgeInitiativeFeature[];
    refPledgeEcosystemTypeFeature: IRefPledgeEcosystemTypeFeature[];
    otherInitiativeInputEnabled: boolean;
    otherEcosystemInputEnabled: boolean;
    anteriorReport?: IReportMainFeature;
    currentPledgeFeature: IRefCurrentPledgeFeature[];
    pledgeFulfilFeature: IRefPledgeFulfilFeature[];
    pledgeImplementFeature: IRefPledgeImplementFeature[];
    otherPledgeImplementInputEnabled: boolean;
    otherPledgeImplementFinancialInputEnabled: boolean;
    previouslyReportedFeature: IRefPreviouslyReportedFeature[];
  }
  const [localState, setTheLocalState] = useState<ILocalState>({
    reportLayerIndex: ConfigService.getConfig().agol?.operationalLayers.reportMain.index,
    importReportDisabled: true,
    refPledgeInitiativeFeature: [],
    refPledgeEcosystemTypeFeature: [],
    otherInitiativeInputEnabled: getOtherInitiativeInputEnabled(props.state.restorationPledgeTrackingTab?.linked_init || ''),
    otherEcosystemInputEnabled: getOtherEcosystemInputEnabled(props.state.restorationPledgeTrackingTab?.ecosystems || ''),
    currentPledgeFeature: [],
    pledgeFulfilFeature: [],
    pledgeImplementFeature: [],
    otherPledgeImplementInputEnabled: getOtherPledgeImpementInputEnabled(props.state.restorationPledgeTrackingTab?.pledge_implementation || ''),
    otherPledgeImplementFinancialInputEnabled: getOtherPledgeImpementFinancialInputEnabled(props.state.restorationPledgeTrackingTab?.pledge_implementation || ''),
    previouslyReportedFeature: []
  });

  const [editorStateAnnoLink, setEditorAnnoLink] = useState(
    () => EditorState.createEmpty(),
  );
  const [editorStatePldgAche, setEditorStatePldgAche] = useState(
    () => EditorState.createEmpty(),
  );

  const [convertedContent, setConvertedContent] = useState('');

  let propscontentLink: any = '';
  // Use effect
  useEffect(() => {
    //Reference table
    getRefFeatures();

    loadContentData(props.state.restorationPledgeTrackingTab!);

  }, [propscontentLink]);

  const loadContentData = (val: any) => {
    if (val.links) {
      propscontentLink = val.links?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorAnnoLink(EditorState.createWithContent(contentState));
    }
    if (val.achievements_learnings) {
      propscontentLink = val.achievements_learnings?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorStatePldgAche(EditorState.createWithContent(contentState));
    }
  }

  const handleEditorChangeAnnoLink = (state: any) => {
    setEditorAnnoLink(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateAnnoLink.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    setParentState('links', Utils.trimWhiteSpace(currentContentAsHTML));
  };

  // const handleEditorChangePldgAche = (state: any) => {
  //   setEditorStatePldgAche(state);
  //   let currentContentAsHTML = JSON.stringify(
  //     draftToHtml(convertToRaw(editorStatePldgAche.getCurrentContent()))
  //   );
  //   setParentState('achievements_learnings', Utils.trimWhiteSpace(currentContentAsHTML));
  // };

  //console.log(convertedContent);
  /**
   * Set parent state
   * @param prop
   * @param value 
   */
  const setParentState = (prop: string, value: any) => {

    if (props.state) {
      const obj: IEditReportState = { ...props.state };
      const subObj: IRestorationPledgeTrackingTab = { ...obj.restorationPledgeTrackingTab } as IRestorationPledgeTrackingTab;

      (subObj as any)[prop] = value;

      // If ecosystem, set RB ha_intervention_types
      if (prop === 'ecosystems') {
        obj.resultsAndBenefitsTab?.resultsAndBenefitsItems?.forEach((i: IResultsAndBenefitsItem) => {
          i.hectaresUnderRestorationTab.ha_intervention_types = '';
        });
      }
      if (prop === 'links') {
        obj.restorationPledgeTrackingTab!.links = convertedContent;
      }

      // Check isOK
      props.validateData(subObj);

      obj.restorationPledgeTrackingTab = subObj;

      props.setState(obj);
    }
  }


  /**
   * Handle pledge end date change
   * @param date
   */
  const handlePledgeEndDateChange = (date: Date) => {
    setParentState('pledge_end', date.getTime());
  }

  const handlePledgeStartDateChange = (date: Date) => {
    setParentState('pledge_start_date', date.getTime());
  }

  /**
   *get end date change
   * @param date
   */
  const getPledgeEndDate = (): Date | undefined => {
    if (props.state.restorationPledgeTrackingTab?.pledge_end) {
      return new Date(props.state.restorationPledgeTrackingTab?.pledge_end);// ? new Date(props.state.restorationPledgeTrackingTab?.pledge_end): new Date();
    }

    return undefined;
  }

  const getPledgeStartDate = (): Date | undefined => {
    if (props.state.restorationPledgeTrackingTab?.pledge_start_date) {
      return new Date(props.state.restorationPledgeTrackingTab?.pledge_start_date);// ? new Date(props.state.restorationPledgeTrackingTab?.pledge_end): new Date();
    }

    return undefined;
  }

  const currPledgeFeature = [
    { key_: '1', value: t("newReport.restorationPledge.Yes") },
    { key_: '2', value: t("newReport.restorationPledge.No") }
  ];

  const previousReportedFeature = [
    { key_: '1', value: t("newReport.restorationPledge.yesReported") },
    { key_: '0', value: t("newReport.restorationPledge.noReported") }
  ];

  const pledgFulfilFeature = [
    { key_: '1', value: t("newReport.restorationPledge.YesFullyTrack") },
    { key_: '2', value: t("newReport.restorationPledge.YesSomewhatTrack") },
    { key_: '3', value: t("newReport.restorationPledge.NotTrack") },
    { key_: '4', value: t("newReport.restorationPledge.InsufficientInformation") }
  ];

  /**
   * Handle initiative change
   * @param date
   */
  const handleInitiativeChange = (items: MultiValue<{ label: string | undefined, value: string | undefined }>) => {    
    const val: string = items && items.length ? items.map(i => i.value).join(',') : '';
    setParentState('linked_init', val);

    props.state.restorationPledgeTrackingTab!.linked_init = val;

    const obj: ILocalState = { ...localState };
    obj.otherInitiativeInputEnabled = getOtherInitiativeInputEnabled(val);
    setTheLocalState(obj);       
  }  

  /**
   * Handle current pledge change
   * @param date
   */
  const handleCurrentPledgeChange = (items: MultiValue<{ label: string | undefined, value: string | undefined }>) => {
    const val: string = items && items.length ? items.map(i => i.value).join(',') : '';
    setParentState('current_pledge', val);

    const obj: ILocalState = { ...localState };
    obj.currentPledgeFeature = currPledgeFeature;
    obj.previouslyReportedFeature = previousReportedFeature;
    setTheLocalState(obj);
  }

  /**
   * Handle pledge fulfil change
   * @param date
   */
  const handlePledgeFulfilChange = (items: MultiValue<{ label: string | undefined, value: string | undefined }>) => {
    const val: string = items && items.length ? items.map(i => i.value).join(',') : '';
    setParentState('pledge_fulfil', val);

    const obj: ILocalState = { ...localState };
    obj.pledgeFulfilFeature = pledgFulfilFeature;
    setTheLocalState(obj);
  }


  /**
   * Handle ecosystem change
   * @param date
   */
  const handleEcosystemChange = (items: MultiValue<{ label: string | undefined, value: string | undefined }>) => {
    const val: string = items && items.length ? items.map(i => i.value).join(',') : '';
    setParentState('ecosystems', val);

    const obj: ILocalState = { ...localState };
    obj.otherEcosystemInputEnabled = getOtherEcosystemInputEnabled(val);
    setTheLocalState(obj);
  }

  /**
   * Handle ecosystem change
   * @param date
   */
  const handlePledgeImplementationChange = (items: MultiValue<{ label: string | undefined, value: string | undefined }>) => {
    const val: string = items && items.length ? items.map(i => i.value).join(',') : '';
    setParentState('pledge_implementation', val);

    props.state.restorationPledgeTrackingTab!.pledge_implementation = val;

    const obj: ILocalState = { ...localState };
    obj.otherPledgeImplementInputEnabled = getOtherPledgeImpementInputEnabled(val);
    
    if(props.state.restorationPledgeTrackingTab!.pledge_implementation.indexOf("2") !== -1)
    {
      obj.otherPledgeImplementFinancialInputEnabled = getOtherPledgeImpementFinancialInputEnabled(val);
    }
    else
    {
      obj.otherPledgeImplementFinancialInputEnabled = false;
    }
    setTheLocalState(obj);
  }

  /**
   * Get reference list
   */
  const getRefFeatures = async () => {
    const fields = ConfigService.getConfig().agol.operationalLayers.reportMain.fields;

    // Ref data
    const sectorFilter = "reporting_entity_type = '2' OR reporting_entity_type = '1,2'";
    const initiativeFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_RESTPLEDGE_INITIATIVE.index), sectorFilter, false, '*', '');
    const ecosystemTypeFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_RESTPLEDGE_ECOSYSTEM_TYPE.index), sectorFilter, false, '*', `${ConfigService.getConfig().agol.referenceTables.REF_RESTPLEDGE_ECOSYSTEM_TYPE.fields.key} ASC`); 
    const pledgeImplementationFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_PLED_IMPLEMENTATION.index), '', false, '*', '');

    //Anterior reports
    let where: string = `${fields.repYear} < ${props.state.report?.attributes[fields.repYear]} AND ${fields.gid0} = '${props.state.report?.attributes[fields.gid0]}'`;

    if (props.state.report?.attributes[fields.gid1]) {
      where = `${where} AND ${fields.gid1} = '${props.state.report?.attributes[fields.gid1]}'`;
    }

    const anteriorReportsFeatures = await QueryService.queryFeatures(Utils.getOpLayerQuery(ConfigService.getConfig().agol.operationalLayers.reportMain.index), where, false, '*', `${fields.repYear} DESC`);

    const obj: ILocalState = { ...localState };
    obj.refPledgeInitiativeFeature = initiativeFeature.map((feat: IFeature) => feat.attributes as IRefPledgeInitiativeFeature);
    obj.refPledgeEcosystemTypeFeature = ecosystemTypeFeature.map((feat: IFeature) => feat.attributes as IRefPledgeEcosystemTypeFeature);
    obj.currentPledgeFeature = currPledgeFeature;
    obj.pledgeFulfilFeature = pledgFulfilFeature;
    obj.previouslyReportedFeature = previousReportedFeature;
    obj.pledgeImplementFeature = pledgeImplementationFeature.map((feat: IFeature) => feat.attributes as IRefPledgeImplementFeature); //pledgImplementFeature;

    if (anteriorReportsFeatures && anteriorReportsFeatures.length > 0) {
      obj.importReportDisabled = false;
      obj.anteriorReport = anteriorReportsFeatures[0] as IReportMainFeature;
    } else {
      obj.importReportDisabled = true;
    }

    setTheLocalState(obj);

    // Validate data
    setValidState();
  };

  /**
  * Set valid state
  */
  const setValidState = () => {
    const obj2: IEditReportState = { ...props.state };
    const subObj: IRestorationPledgeTrackingTab = { ...obj2.restorationPledgeTrackingTab } as IRestorationPledgeTrackingTab;

    if (subObj) {
      props.validateData(subObj);
    }

    obj2.restorationPledgeTrackingTab = subObj;
    props.setState(obj2);
  }

  /**
   * Handle import report
   */
  const importReport = () => {
    // toast('This feature is not yet available');

    if (localState && localState.anteriorReport && props.state) {
      const obj: IEditReportState = { ...props.state };
      const subObj: IRestorationPledgeTrackingTab = { ...obj.restorationPledgeTrackingTab } as IRestorationPledgeTrackingTab;

      //subObj.ha_pledged = localState.anteriorReport.attributes.ha_pledged;
      //subObj.baseline_year = localState.anteriorReport.attributes.baseline_year;
      subObj.pledge_start_date = localState.anteriorReport.attributes.pledge_start_date;
      subObj.pledge_end = localState.anteriorReport.attributes.pledge_end;
      subObj.linked_init = localState.anteriorReport.attributes.linked_init || '';
      subObj.linked_init_other = localState.anteriorReport.attributes.linked_init_other || '';
      subObj.ecosystems = localState.anteriorReport.attributes.ecosystems || '';
      subObj.ecosystems_other = localState.anteriorReport.attributes.ecosystems_other || '';
      subObj.links = localState.anteriorReport.attributes.links || '';

      obj.restorationPledgeTrackingTab = subObj;

      props.setState(obj);
    }
  }


  /**
   * Check if a field is required
   * @param field
   */
  const isRequired = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportMain.psRequiredFields.restorationPledgeTracking, field);
  }

  return (
    <div className="oneTabContent restorationPledgeTab">
      <span className="bigText">{t('newReport.restorationPledge.label')}</span>

      <div className="separtorDiv"></div>

      <div className="row">
        <span className="titleSpan mediumText">8a. {t('newReport.restorationPledge.isPreviouslyReported')}</span>
        <div className="col-2 singleDDLDiv">
          <select className="mediumText"
            value={props.state.restorationPledgeTrackingTab?.is_previously_reported || '-999'}
            onChange={(e) => { setParentState('is_previously_reported', e.target.value) }}>
            {<option value="-999" key="">{t('newReport.restorationPledge.selectOnePlacehodler')}</option>}
            {localState.previouslyReportedFeature.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
          </select>
        </div>
      </div>

      <div className="row">
        <span className="titleSpan mediumText">8b. {t('newReport.restorationPledge.reportingperiod')}</span>
        <span className="titleSpan mediumText">{t('newReport.restorationPledge.pledgeStartYear')}</span>
        <ReactDatePicker 
          className={`txtPledgeDate ${isRequired('pledge_start_date') ? "required" : ""}`}  
          dateFormat="MMMM yyyy"
          selected={getPledgeStartDate()}
          onChange={(date: Date) => handlePledgeStartDateChange(date)}
          dropdownMode="select"
          showMonthYearPicker
        />
      </div>


      <div className="row">
        <span className="titleSpan mediumText">
          {t('newReport.restorationPledge.pledgeEndDate')}
        </span>
        <ReactDatePicker className={`txtPledgeDate ${isRequired('pledge_end') ? "required" : ""}`}   dateFormat="MMMM yyyy" selected={getPledgeEndDate()} onChange={(date: Date) => handlePledgeEndDateChange(date)} dropdownMode="select" showMonthYearPicker />
      </div>

      {localState.refPledgeInitiativeFeature && localState.refPledgeInitiativeFeature.length > 0 &&
        <div className={`row multiselectRow ${isRequired('linked_init') ? "required" : ""}`}>
          <span className="titleSpan mediumText">9. {t('newReport.restorationPledge.pledgeInitiative')}</span>

          <div className="col-6">
            <Select classNamePrefix="multiselect" placeholder={t('newReport.restorationPledge.pledgeInitiativePlaceholder')}
              closeMenuOnSelect={true} isMulti
              options={localState.refPledgeInitiativeFeature.map((i: IRefPledgeInitiativeFeature) => { return { label: i.value, value: i.key_ } })}
              onChange={handleInitiativeChange}
              value={
                localState.refPledgeInitiativeFeature.map((i: IRefPledgeInitiativeFeature) => { return { label: i.value, value: i.key_ } })
                  .filter(option => (props.state.restorationPledgeTrackingTab?.linked_init || '').split(',').indexOf(option.value || '---') !== -1)
              } />
          </div>

          <div className="col-6">
            <input className="mediumText big right" type="text" required={isRequired('linked_init_other')}
              maxLength={Utils.getFieldInfos(localState.reportLayerIndex, 'linked_init_other')?.length} placeholder={t('newReport.ifOtherSelected')}
              disabled={!localState.otherInitiativeInputEnabled} value={props.state.restorationPledgeTrackingTab?.linked_init_other} onChange={(e) => { setParentState('linked_init_other', e.target.value) }} />
          </div>
        </div>
      }

      {props.state.restorationPledgeTrackingTab?.linked_init?.toString().indexOf('4') != -1 &&
        <>
          <div className="row">
            <span className="titleSpan mediumText">9a. {t('newReport.restorationPledge.pledgeAnnouncementLinks')}</span>
            <div className="alEditorDiv">
              <Editor
                editorState={editorStateAnnoLink}
                onEditorStateChange={handleEditorChangeAnnoLink}
                wrapperClassName="wrapper-class"
                editorClassName="editor-class"
                toolbarClassName="toolbar-class"
                toolbar={{
                  options: ['link'],
                  link: { inDropdown: true },
                }}
              />
            </div>
          </div>

          {/* <div className="row">
            <span className="titleSpan mediumText">{t('newReport.restorationPledge.pledgeCurrent')}</span>
            <div className="col-5 singleDDLDiv">
              <select className="mediumText"
                value={props.state.restorationPledgeTrackingTab?.current_pledge || '-999'}
                onChange={(e) => { setParentState('current_pledge', e.target.value) }}>
                {<option value="-999" key="">{t('newReport.restorationPledge.selectOnePlacehodler')}</option>}
                {localState.currentPledgeFeature.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
              </select>
            </div><br></br>
            <span className="titleSpan mediumText pledgeNote">{t('newReport.restorationPledge.NoPledgeNote')}</span>
          </div> */}
        </>
      }
      {localState.refPledgeEcosystemTypeFeature && localState.refPledgeEcosystemTypeFeature.length > 0 &&
        <div className={`row multiselectRow ${isRequired('ecosystems') ? "required" : ""}`}>
          <span className="titleSpan mediumText">10. {t('newReport.restorationPledge.pledgeEcosystem')}</span>

          <div className="col-6">
            <Select classNamePrefix="multiselect" placeholder={t('newReport.restorationPledge.pledgeEcosystemPlaceholder')}
              closeMenuOnSelect={true} isMulti
              options={localState.refPledgeEcosystemTypeFeature.map((i: IRefPledgeEcosystemTypeFeature) => { return { label: i.value, value: i.key_ } })}
              onChange={handleEcosystemChange}
              value={
                localState.refPledgeEcosystemTypeFeature.map((i: IRefPledgeEcosystemTypeFeature) => { return { label: i.value, value: i.key_ } })
                  .filter(option => (props.state.restorationPledgeTrackingTab?.ecosystems || '').split(',').indexOf(option.value || '---') !== -1)
              } />
          </div>

          <div className="col-6">
            <input className="mediumText big right" type="text" required={isRequired('ecosystems_other')}
              maxLength={Utils.getFieldInfos(localState.reportLayerIndex, 'ecosystems_other')?.length} placeholder={t('newReport.ifOtherSelected')}
              disabled={!localState.otherEcosystemInputEnabled} value={props.state.restorationPledgeTrackingTab?.ecosystems_other} onChange={(e) => { setParentState('ecosystems_other', e.target.value) }} />
          </div>
        </div>
      }

      {localState.pledgeImplementFeature && localState.pledgeImplementFeature.length > 0 &&
        <div className={`row multiselectRow ${isRequired('pledge_implementation') ? "required" : ""}`}>
          <span className="titleSpan mediumText">11. {t('newReport.restorationPledge.pledgeImplement')}</span>
          <div className="col-6">
            <Select
              classNamePrefix="multiselect" placeholder={t('newReport.restorationPledge.pledgeImplementPlaceholder')}
              closeMenuOnSelect={true} isMulti
              options={localState.pledgeImplementFeature.map((i: IRefPledgeImplementFeature) => { return { label: i.value, value: i.key_ } })}
              onChange={handlePledgeImplementationChange}
              value={
                localState.pledgeImplementFeature.map((i: IRefPledgeImplementFeature) => { return { label: i.value, value: i.key_ } })
                  .filter(option => (props.state.restorationPledgeTrackingTab?.pledge_implementation || '').split(',').indexOf(option.value || 'Select') !== -1)
              } />
          </div>          

          <div className="col-6">
            <input className="mediumText big right" type="text" required={isRequired('pledge_implementation_other')}
              maxLength={Utils.getFieldInfos(localState.reportLayerIndex, 'pledge_implementation_other')?.length} placeholder={t('newReport.ifOtherSelected')}
              disabled={!localState.otherPledgeImplementInputEnabled} value={localState.otherPledgeImplementInputEnabled? props.state.restorationPledgeTrackingTab?.pledge_implementation_other: ''} onChange={(e) => { setParentState('pledge_implementation_other', e.target.value) }} />

          {props.state.restorationPledgeTrackingTab?.pledge_implementation  &&
            <input className="mediumText big right margTen" type="text" required={isRequired('pledge_impl_financial_support')}
              maxLength={Utils.getFieldInfos(localState.reportLayerIndex, 'pledge_impl_financial_support')?.length} placeholder={t('newReport.restorationPledge.ifFinancialSupportSelected')}
              disabled={!localState.otherPledgeImplementFinancialInputEnabled} value={localState.otherPledgeImplementFinancialInputEnabled? props.state.restorationPledgeTrackingTab?.pledge_impl_financial_support: ''} onChange={(e) => { setParentState('pledge_impl_financial_support', e.target.value) }} />
           
          }    
           </div>
        </div>
      }

      {/* <div className="row">
        <span className="titleSpan mediumText">{t('newReport.restorationPledge.pledgeachievements')}</span>
        <div className="alEditorDiv">
          <Editor
            editorState={editorStatePldgAche}
            onEditorStateChange={handleEditorChangePldgAche}
            wrapperClassName="wrapper-class"
            editorClassName="editor-class"
            toolbarClassName="toolbar-class"
            toolbar={{
              options: ['link'],
              link: { inDropdown: true },
            }}
          />
        </div>        
      </div> */}

      <div className="row pledgeFulfilDiv">
        <span className="titleSpan mediumText">12. {t('newReport.restorationPledge.pledgeFulfil')}</span>
        <div className={`col-5 singleDDLDiv minwidth50 ddlPaddingDiv ${isRequired('pledge_fulfil') ? "required" : ""}`}>
          <select className="mediumText requiredField"
            value={props.state.restorationPledgeTrackingTab?.pledge_fulfil || '-999'}
            onChange={(e) => { setParentState('pledge_fulfil', e.target.value) }}>
            {<option value="-999" key="">{t('newReport.restorationPledge.selectOnePlacehodler')}</option>}
            {localState.pledgeFulfilFeature.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
          </select>
        </div>
      </div>

      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover />

    </div>
  );
};

export default SectorRestorationPledge;

